 'use client';

 import { useI18n } from '@/shared/providers/I18nProvider';

export function ThumbnailPlaceholder() {
  const { dict } = useI18n();
  return (
    <div
      className="relative w-full shrink-0 overflow-clip aspect-[1.15] flex items-center justify-center bg-neutral-100"
      aria-hidden
    >
      <span className="text-xs text-neutral-400">{dict.common.noImage}</span>
    </div>
  );
}
